import { takeEvery, put } from "redux-saga/effects"

//Account Redux states
import { CHECK_AUTH_TYPE } from "./actionTypes"
import { checkAuthTypeSuccessful, checkAuthTypeFailed } from "./actions"

function* onCheckAuthType({callback}) {
  try {
    const checkAuth = localStorage.getItem("number");
    callback && callback(checkAuth);
    yield put(checkAuthTypeSuccessful(checkAuth));

  } catch (error) {
    yield put(checkAuthTypeFailed(error))
  }
}

function* authTypeSaga() {
  yield takeEvery(CHECK_AUTH_TYPE, onCheckAuthType)
}

export default authTypeSaga;
